import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import index from './views/index.vue'
import education from './views/education/education.vue'
import educationAdministration from './views/education/education-administration.vue'
import educationTeaching from './views/education/education-teaching.vue'
import educationRecruit from './views/education/education-recruit.vue'
import retail from './views/retail/retail.vue'
import retailMarketing from './views/retail/retail-marketing.vue'
import retailDigitization from './views/retail/retail-digitization.vue'
import retailMiddleGround from './views/retail/retail-middle-ground.vue'
import cooperation from './views/cooperation/cooperation.vue'
import scrm from './views/scrm/scrm.vue'
import we from './views/we/we.vue'

export default new Router({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/education',
      name: 'education',
      component: education
    },
    {
      path: '/educationAdministration',
      name: 'educationAdministration',
      component: educationAdministration
    },
    {
      path: '/educationTeaching',
      name: 'educationTeaching',
      component: educationTeaching
    },
    {
      path: '/educationRecruit',
      name: 'educationRecruit',
      component: educationRecruit
    },
    {
      path: '/retail',
      name: 'retail',
      component: retail
    },
    {
      path: '/retailMarketing',
      name: 'retailMarketing',
      component: retailMarketing
    },
    {
      path: '/retailDigitization',
      name: 'retailDigitization',
      component: retailDigitization
    },
    {
      path: '/retailMiddleGround',
      name: 'retailMiddleGround',
      component: retailMiddleGround
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: cooperation
    },
    {
      path: '/scrm',
      name: 'scrm',
      component: scrm
    },
    {
      path: '/we',
      name: 'we',
      component: we
    },
  ]
})
